import Salesforce from '@clearkit/icons/services/Salesforce';
import { CKBadge, CKBadgeVariant, CKButton, CKCardCollapsible } from 'clearkit';
import { Link } from 'react-router-dom';

import { useFeatureFlag } from '~/hooks/account';

import { useHasCaptureAccess } from '../../../../hooks/account/usePlatformAccess';
import CaptureLogo from './capture.svg';
import SalesforceAccount from './sf_account.svg';
import SalesforceContact from './sf_contact.svg';
import SalesforceLead from './sf_lead.svg';

function SyncSalesforceBadge() {
  return (
    <div className="flex items-center gap-2">
      <Salesforce className="w-6 h-6" />
      <div className="text-sm font-medium text-gray-500">
        Syncs with
        <div className="font-semibold text-gray-600">Salesforce</div>
      </div>
    </div>
  );
}

function CapturePlanPanel({ icon, title, description }) {
  const Icon = icon;

  return (
    <div className="flex flex-col items-center justify-between px-4 py-8 border border-gray-200 rounded gap-2">
      <Icon className="w-10 h-10" />
      <h3 className="text-base font-semibold">{title}</h3>
      <p className="mb-5 text-sm text-center">{description}</p>
      <SyncSalesforceBadge />
    </div>
  );
}

const IS_HIDDEN = true;

export default function AddCapturePlan() {
  const captureFlaggedOff = useFeatureFlag(
    'x_destination_create_salesforce_account',
  ).disabled;
  const captureEnabled = useHasCaptureAccess();

  if (captureEnabled || captureFlaggedOff || IS_HIDDEN) {
    return null;
  }

  return (
    <CKCardCollapsible isOpen>
      <CKCardCollapsible.Header>
        <div className="flex items-center gap-2">
          <CaptureLogo className="w-9 h-9" />
          <h3 className="text-base font-medium text-gray-900">
            Add Capture to your Clearbit account
          </h3>
          <CKBadge className="bg-yellow-400" variant={CKBadgeVariant.rounded}>
            Add-on
          </CKBadge>
        </div>
      </CKCardCollapsible.Header>
      <CKCardCollapsible.Body>
        <div className="flex gap-5">
          <CapturePlanPanel
            title="Salesforce account"
            icon={SalesforceAccount}
            description={
              <>
                Create a Salesforce account when a company that is not in your
                CRM enters the audience.{' '}
                <a
                  href="https://help.clearbit.com/hc/en-us/articles/8719323175319"
                  className="ck-link">
                  Learn more
                </a>
              </>
            }
          />
          <CapturePlanPanel
            title="Salesforce contacts"
            icon={SalesforceContact}
            description={
              <>
                Create Salesforce contacts automatically for specific personas
                when a company enters this audience.{' '}
                <a
                  href="https://help.clearbit.com/hc/en-us/articles/8719321819927"
                  className="ck-link">
                  Learn more
                </a>
              </>
            }
          />
          <CapturePlanPanel
            title="Salesforce leads"
            icon={SalesforceLead}
            description={
              <>
                Create Salesforce leads automatically for specific personas when
                a company enters this audience.{' '}
                <a
                  href="https://help.clearbit.com/hc/en-us/articles/8719266018711"
                  className="ck-link">
                  Learn more
                </a>
              </>
            }
          />
        </div>
        <CKCardCollapsible.Footer className="flex justify-end">
          <CKButton
            as={Link}
            to={{
              pathname: `destinations/contact-success/capture`,
            }}
            variant="bold"
            variantColor="blue">
            Contact success team
          </CKButton>
        </CKCardCollapsible.Footer>
      </CKCardCollapsible.Body>
    </CKCardCollapsible>
  );
}
